import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

const cardImages: Record<string, string> = {
  'access-methods': 'https://readdy.ai/api/search-image?query=Modern%20laptop%20and%20smartphone%20displaying%20web%20portal%20login%20screen%2C%20warm%20amber%20and%20cream%20color%20scheme%2C%20clean%20minimalist%20desk%20setup%2C%20soft%20natural%20lighting%2C%20editorial%20photography%20style%2C%20professional%20and%20secure%20atmosphere&width=600&height=400&seq=cat-access&orientation=landscape',
  'features': 'https://readdy.ai/api/search-image?query=Modern%20digital%20dashboard%20with%20various%20tool%20cards%20and%20feature%20icons%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20UI%20design%2C%20soft%20studio%20lighting%2C%20editorial%20technology%20photography%2C%20organised%20and%20functional%20layout&width=600&height=400&seq=cat-features&orientation=landscape',
  'tutorials': 'https://readdy.ai/api/search-image?query=Step%20by%20step%20tutorial%20guide%20on%20a%20laptop%20screen%20with%20numbered%20instructions%2C%20warm%20orange%20accents%2C%20clean%20minimalist%20workspace%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20educational%20and%20welcoming%20atmosphere&width=600&height=400&seq=cat-tutorials&orientation=landscape',
  'faq': 'https://readdy.ai/api/search-image?query=Organised%20FAQ%20webpage%20with%20question%20and%20answer%20cards%20on%20screen%2C%20warm%20cream%20and%20orange%20color%20palette%2C%20clean%20modern%20design%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20helpful%20and%20informative%20atmosphere&width=600&height=400&seq=cat-faq&orientation=landscape',
  'latest-news': 'https://readdy.ai/api/search-image?query=Modern%20news%20and%20update%20announcement%20interface%20with%20highlighted%20cards%2C%20warm%20orange%20and%20cream%20tones%2C%20clean%20design%2C%20soft%20studio%20lighting%2C%20editorial%20photography%2C%20fresh%20and%20dynamic%20atmosphere&width=600&height=400&seq=cat-news&orientation=landscape',
};

export default function CategoryCards() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            探索功能分类
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            按分类浏览免费91网页的完整内容，快速找到你需要的使用指南和教程
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cardImages[cat.slug] || cardImages['features']}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/90 text-background-50">
                      <i className={`${cat.icon} text-sm`}></i>
                    </div>
                    <h3 className="text-lg font-semibold font-heading text-background-50">
                      {cat.name}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  查看所有{cat.name}相关文章与指南，了解更多使用技巧
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-sm font-medium text-primary-500 group-hover:text-primary-600 whitespace-nowrap">
                  浏览文章
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}